const childRoutes = prop => [
    {
        path: 'billing-history-list',
        name: prop + '.billing_history_list',
        meta: { auth: true },
        component: () => import('../pages/billing-information-management/billing-history-list/List.vue')
    },
    {
        path: 'thirty-percent-free-treatment-report',
        name: prop + '.thirty_percent_free_treatment_report',
        meta: { auth: true },
        component: () => import('../pages/billing-information-management/thirty-percent-free-treatment-report/List.vue')
    },
    {
        path: 'billing-report',
        name: prop + '.billing_report',
        meta: { auth: true },
        component: () => import('../pages/billing-information-management/billing-report/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/billing-information-management',
        name: 'hospital_disability_service.billing_information_management',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.billing-information-management')
    }
]

export default routes
